import Modal from "react-bootstrap/Modal";

export type PopupProps = {
  show: boolean;
  header: string | React.ReactNode;
  secondHeader?: string | React.ReactNode;
  headeIconButtons?: React.ReactNode;
  size?: "sm" | "lg" | "xl" | undefined;
  onClose: () => void;
  hasButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  submitFormId?: string | undefined;
  submitButtonText?: string;
  secondButtonText?: string;
  onSecondButtonClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  canEdit?: boolean;
  backdrop?: "static" | true | false;
  footer?: React.ReactNode;
  enforceFocus?: boolean;
};

export default function Popup({
  show,
  header,
  secondHeader,
  headeIconButtons,
  size,
  onClose,
  className,
  style,
  children,
  backdrop = true,
  footer,
  enforceFocus = true,
}: PopupProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size={size}
      className={className}
      style={style}
      scrollable
      centered={false}
      backdrop={backdrop}
      backdropClassName="modal-backdrop-blur"
      aria-labelledby="wizard-modal-title"
      enforceFocus={enforceFocus}
    >
      <div className="modal-header d-block">
        <div className="d-flex align-items-center justify-content-between">
          {typeof header === "string" ? (
            <h2
              id="wizard-modal-title"
              className="modal-title mb-0"
              style={{ fontSize: "1.25rem", fontWeight: "inherit", margin: 0 }}
            >
              {header}
            </h2>
          ) : (
            <h2
              id="wizard-modal-title"
              className="flex-grow-1 d-flex align-items-center gap-2"
              style={{ fontSize: "1.25rem", fontWeight: "inherit", margin: 0 }}
            >
              {header}
            </h2>
          )}
          <div className="d-flex align-items-center">
            {headeIconButtons}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
              style={{
                filter: "invert(1) grayscale(100%) brightness(200%)",
                opacity: 1,
              }}
            ></button>
          </div>
        </div>
        {secondHeader &&
          (typeof secondHeader === "string" ? (
            <div className="modal-title mb-0" style={{ fontSize: "1.5rem" }}>
              {secondHeader}
            </div>
          ) : (
            <div className="flex-grow-1">{secondHeader}</div>
          ))}
      </div>
      <Modal.Body
        className="p-0 wizard-content"
        style={{
          minHeight: "400px",
          maxHeight: "calc(100vh - 200px)",
          overflowY: "auto",
          backgroundColor: "#fff",
        }}
      >
        {children}
      </Modal.Body>
      {footer && (
        <Modal.Footer
          style={{
            borderTop: "1px solid #dee2e6",
            padding: "16px 24px",
            backgroundColor: "#fff",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          {footer}
        </Modal.Footer>
      )}
    </Modal>
  );
}
